import BN from "bn.js";
import { MAX_BPS, MAX_FEE_BASIS_POINTS } from "./constant";

export function calculateFeeExcludedAmount(
  amount: BN,
  feeBps: number,
): { feeExcludedAmount: BN; feeAmount: BN } {
  if (feeBps === 0) {
    return { feeExcludedAmount: amount, feeAmount: new BN(0) };
  }

  // Ceiling division: feeAmount = ceil(amount * feeBps / 10000)
  const feeAmount = amount
    .mul(new BN(feeBps))
    .add(MAX_BPS.subn(1))
    .div(MAX_BPS);

  const feeExcludedAmount = amount.sub(feeAmount);

  return { feeExcludedAmount, feeAmount };
}
